module.exports = __webpack_public_path__ + "static/media/refresh.d38057f7.svg";